import axios from 'axios'
import '@/api'
import { extract } from './utils'
import { merge } from 'lodash'
import { saveAs } from 'file-saver'

// ------------------------------------
// Endpoint Configuration
// ------------------------------------

const endpointConfig = {
  orders: {
    url: '/orders'
  },
  orderReview: {
    url: '/pdf/product-request-review',
    // responseType: 'blob',
    // headers: {
    //   'Accept': 'application/pdf',
    // }
  }
}

// ------------------------------------
// Initial State
// ------------------------------------

const state = {
  order: {},
  orders: []
}

// ------------------------------------
// Getters
// ------------------------------------

const getters = {
  order: state => state.order,
  orders: state => state.orders
}

// ------------------------------------
// Constants
// ------------------------------------

const REQUEST_GET_ORDER = 'REQUEST_GET_ORDER'
const RECEIVE_GET_ORDER = 'RECEIVE_GET_ORDER'

const REQUEST_CREATE_ORDER = 'REQUEST_CREATE_ORDER'
const RECEIVE_CREATE_ORDER = 'RECEIVE_CREATE_ORDER'

const REQUEST_UPDATE_ORDER = 'REQUEST_UPDATE_ORDER'
const RECEIVE_UPDATE_ORDER = 'RECEIVE_UPDATE_ORDER'

const REQUEST_DELETE_ORDER = 'REQUEST_DELETE_ORDER'
const RECEIVE_DELETE_ORDER = 'RECEIVE_DELETE_ORDER'

const CLEAR_ORDER = 'CLEAR_ORDER'

const UPDATE_ORDER_PROPERTY = 'UPDATE_ORDER_PROPERTY'

const REQUEST_GET_ORDERS = 'REQUEST_GET_ORDERS'
const RECEIVE_GET_ORDERS = 'RECEIVE_GET_ORDERS'

// ------------------------------------
// Actions
// ------------------------------------

const actions = {
  async getOrders ({ commit, dispatch }, { includes = undefined, filters = undefined, sort = undefined }) {
    dispatch('wait/start', 'getting orders', { root: true })
    commit(REQUEST_GET_ORDERS)
    const config = merge({}, endpointConfig.orders, { params: merge({}, filters, { include: includes }, { sort: sort }) })
    console.log(config)
    return axios.get(endpointConfig.orders.url, config)
      .then((response) => {
        dispatch('receiveOrders', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting orders', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting orders', { root: true })
        return Promise.reject(error)
      })
  },
  async getOrder ({ commit, dispatch }, { id, includes = undefined }) {
    dispatch('wait/start', 'getting order', { root: true })
    commit(REQUEST_GET_ORDER, id)
    const config = merge({}, endpointConfig.orders, { params: { include: includes } })
    return axios.get(`${endpointConfig.orders.url}/${id}`, config)
      .then((response) => {
        dispatch('receiveOrder', [ response.data, 'GET' ])
        dispatch('wait/end', 'getting order', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'getting order', { root: true })
        return Promise.reject(error)
      })
  },
  async createOrder ({ commit, dispatch }, { data, includes = undefined }) {
    dispatch('wait/start', 'creating order', { root: true })
    commit(REQUEST_CREATE_ORDER, data)
    const config = merge({}, endpointConfig.orders, { params: { include: includes } })
    return axios.post(`${endpointConfig.orders.url}`, data, config)
      .then((response) => {
        dispatch('receiveOrder', [ response.data, 'CREATE' ])
        dispatch('wait/end', 'creating order', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'creating order', { root: true })
        return Promise.reject(error)
      })
  },
  async updateOrder ({ commit, dispatch }, { id, data, includes = undefined }) {
    dispatch('wait/start', 'updating order', { root: true })
    commit(REQUEST_UPDATE_ORDER, id)
    const config = merge({}, endpointConfig.orders, { params: { include: includes } })
    return axios.put(`${endpointConfig.orders.url}/${id}`, data, config)
      .then((response) => {
        dispatch('receiveOrder', [ response.data, 'UPDATE' ])
        dispatch('wait/end', 'updating order', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'updating order', { root: true })
        return Promise.reject(error)
      })
  },
  async deleteOrder ({ commit, dispatch }, id) {
    dispatch('wait/start', 'deleting order', { root: true })
    commit(REQUEST_DELETE_ORDER, id)
    return axios.delete(`${endpointConfig.orders.url}/${id}`, endpointConfig.orders)
      .then((response) => {
        commit(RECEIVE_DELETE_ORDER, response.data)
        dispatch('wait/end', 'deleting order', { root: true })
        return Promise.resolve(true)
      })
      .catch((error) => {
        dispatch('wait/end', 'deleting order', { root: true })
        return Promise.reject(error)
      })
  },
  receiveOrder ({ commit }, [ json, action ]) {
    commit(`RECEIVE_${action}_ORDER`, extract(json))
    return json.data
  },
  receiveOrders ({ commit }, [ json, action ]) {
    commit(`RECEIVE_${action}_ORDERS`, extract(json))
    return json.data
  },
  updateOrderProperty ({ commit }, [ property, value ]) {
    commit(`UPDATE_ORDER_PROPERTY`, [ property, value ])
  },
  async downloadOrderReview({ dispatch }, id) {
    dispatch('wait/start', 'downloading order review', { root: true })
    window.open(`${ process.env.VUE_APP_API_BASE_URL }${ endpointConfig.orderReview.url }/${ id }`) // TODO: Improve
    dispatch('wait/end', 'downloading order review', { root: true })
  },

}

// ------------------------------------
// Mutations
// ------------------------------------

const mutations = {
  [REQUEST_GET_ORDER] (state, id) {
  },
  [RECEIVE_GET_ORDER] (state, json) {
    state.order = json
  },
  [REQUEST_CREATE_ORDER] (state, json) {
  },
  [RECEIVE_CREATE_ORDER] (state, json) {
    state.order = json
  },
  [REQUEST_UPDATE_ORDER] (state, id) {
  },
  [RECEIVE_UPDATE_ORDER] (state, json) {
    state.order = json
  },
  [REQUEST_DELETE_ORDER] (state, id) {
  },
  [RECEIVE_DELETE_ORDER] (state, json) {
    state.order = {}
  },
  [CLEAR_ORDER](state, json) {
    state.order = {}
  },
  [UPDATE_ORDER_PROPERTY] (state, [ property, value ]) {
    state.order[property] = value
  },
  [REQUEST_GET_ORDERS] (state) {
  },
  [RECEIVE_GET_ORDERS] (state, json) {
    state.orders = json
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
